<div class="w-full min-w-0">
  <p-floatlabel variant="on" class="w-full">
    @if (numberPrice() === true) {
      <p-inputnumber
        fluid
        [formControl]="control()"
        mode="decimal"
        [minFractionDigits]="2"
        size="small"
        [name]="name()"
      />
    } @else {
      <input
        pInputText
        fluid
        pSize="small"
        [type]="type()"
        [formControl]="control()"
        [name]="name()"
      />
    }
    <label>{{ label() }}</label>
  </p-floatlabel>
</div>

@if (control().invalid && control().touched) {
  <div class="flex flex-col gap-1">
    @if (control().hasError('required')) {
      <small class="text-red-600 dark:text-red-400 text-[10px] font-medium mt-1 pl-2">{{ 'shared.validationMessages.required' | translate }}</small>
    }
    @if (type() === 'email' && control().hasError('email')) {
      <small class="text-red-600 dark:text-red-400 text-[10px] font-medium mt-1 pl-2">{{ 'shared.validationMessages.emailInvalid' | translate }}</small>
    }
    @if (control().hasError('minlength')) {
      <small class="text-red-600 dark:text-red-400 text-[10px] font-medium mt-1 pl-2">{{ 'shared.validationMessages.tooShort' | translate }}</small>
    }
    @if (control().hasError('maxlength')) {
      <small class="text-red-600 dark:text-red-400 text-[10px] font-medium mt-1 pl-2">{{ 'shared.validationMessages.tooLong' | translate }}</small>
    }
  </div>
}
